import { useMemo } from "react";
import logo from './media/logo2.png';

function Lb({ children }) {
  return (
    <span
      style={{
        fontWeight: 400,
        textShadow: "0px 0px 1px rgba(0, 0, 0, 0.5)",
        /* Add a subtle text shadow for emphasis */
      }}
    >
      {children}
    </span>
  );
}

const slogans = [
  [
    "Chuck Norris doesn’t need us. But ",
    <b>
      <i>you</i>
    </b>,
    " do.",
  ],
  [
    "We can’t fix your PhD, but we ",
    <i>
      <b>can</b>
    </i>,
    " fix your figures.",
  ],
  "Figures without tears.",
  "A figure creator that doesn't hate you.",
  "A figure creator younger than grampa.",
  "Figures in seconds. Clock's ticking. Get moving.",
  "Figures without tears.",
  "Grow up. Ditch the crayons (🖍️)",
  "Because it's not 1999... ❌ 💾",
  "Used to take 15 minutes for a few figures? LOL.",
  "Stop the bleeding 🩸",
  "Making figures shouldn't feel like hell 👺",
  "You can no longer blame your balding on figure-related stress.",
  //"A tool that doesn't make you feel like a todler.",
  "Gramma shouldn't be worrying about your figures.",
  "If you know, you know.",
  "Figures so clean, even Reviewer #2 will shut up.",
  [
    "Fix your figures ",
    <b>
      <i>before</i>
    </b>,
    " your PI fixes you.",
  ],
  "Figure-making no longer requires you to 'lock-in'.",
  "So your figures ",<i>aren't</i>,"the reason reviewers drink.",
  "So your figures don't set research back 10 years.",
  "Figures that ",<i>don't</i>," make your eyes bleed.",
  "Viewing figures shouldn't require an eyewash station.",
  "With figures like these, your PI will stop ignoring your emails.",
  "Your PI still may beg your to quit, but it won't be because of your figures.",
  "We'll make sure your dog doesn't eat your raw data.",
  "Because fignorance is not bliss.",
  ["We make the replicates you ", <i>do</i>, " show look good."],

  "Your data deserves better. So do your co-authors.",

  "At least now your figures are better than your explanations.",

  "PowerPoint hates you. Stop using it.",

  "We intentionally built a figure-creation app that doesn't suck.",
];

export default function TitleContainer({ mobile }) {
  const slogan = useMemo(() => {
    return slogans[Math.round(Math.random() * (slogans.length - 1))];
  }, []);

  return (
    <div
      style={{
        textAlign: mobile ? "center" : "unset",
        //border:'3px solid lime',
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: 'center',
        flexDirection: "column",
      }}
    >
      <div style={{display:'flex',flexDirection:'column',alignItems:'center'}}>
        {/*<div
          style={{
            fontSize: mobile ? "10vw" : "4vw",
            borderRadius: 5,
            color: "rgba(0,129,255)",
            fontWeight: 250,
            textAlign: 'center',
            //fontVariant:'small-caps',
          }}
        >
          Lab Figures
        </div>*/}
        <img src={logo} style={{height: 200, marginBottom: 20}} />

        <div
          style={{
            fontSize: mobile ? "4vw" : "2vw",
            color: "#222",
            //fontFamily:'Roboto',
            fontWeight: 100,
            //fontVariant:'small-caps',
          }}
        >
          {false && slogans.map((ss) => <div>{ss}</div>)}
          {"Modern figure creation tools."}
        </div>
      </div>
    </div>
  );
}
